import React, { useEffect } from 'react'
import { useState } from 'react'
import axios from 'axios'
import { DateRangePicker } from 'rsuite'

import { usePDF, Document, Page, BlobProvider } from '@react-pdf/renderer'
import DailyReport from './PDF/Daily'
import { CSVLink, CSVDownload } from 'react-csv'
const PrePayment = () => {
  const [dateRange, setDateRange] = useState(null)
  const [error, setError] = useState('')
  const [loadingDate, setLoadingDate] = useState(false)
  const [csvdata, setCSVDate] = useState(null)

  const arrayRestrusture = (csvdata) => {
    //console.log(csvdata)
    let dt = []
    let obj = {}

    for (let i = 0; i < csvdata.length; i++) {
      const opr = csvdata[i].operator.reduce(
        (first, second, idx) =>
          idx == 0
            ? 'Name: ' +
              (second?.operator?.fname ?? '') +
              ' | M: ' +
              (second?.operator?.phone ?? '')
            : first +
              ' , ' +
              'Name: ' +
              (second?.operator?.fname ?? '') +
              ' | M: ' +
              (second?.operator?.phone ?? ''),
        '',
      )

      const prtdt = csvdata[i]?.order_list[0]?.order_list_products
        .map((product) => {
          const productName = product?.product_name ?? ''
          const quantity = product?.quantity ?? ''
          const quantityType = product?.quantitytype ?? ''
          const xeroCode = product?.xero_code ?? ''
          const unitPrice = product?.unit_price ?? ''
          const spreadChargeRate = product?.spreadchargerate?.name ?? ''

          return `${productName}|${quantity}|${quantityType}|${xeroCode}|${unitPrice}|${spreadChargeRate}`
        })
        .join('\n')

      const mix_price = csvdata[i]?.order_list[0]?.order_list_products
        .filter((product) => product?.product_name !== 'FRE' && product?.is_customer_product !== 1)
        .reduce((total, product) => {
          const mixPercentage = parseFloat(product?.mix_percentage) || 0
          const unitPrice = parseFloat(product?.unit_price) || 0
          const proportionatePrice = (mixPercentage / 100) * unitPrice
          return total + proportionatePrice
        }, 0)
        .toFixed(3)

      const docket_details = csvdata[i]?.order_list[0]?.docket_numbers
        .map((docket) => docket?.docket_number ?? '')
        .join('|')

      const lineTotals = csvdata[i].line_items.map((lineItem) => {
        const quantity = parseFloat(lineItem?.quantity) || ''
        const amount = parseFloat(lineItem?.amount) || ''
        return quantity * amount
      })

      const grand_total = lineTotals.reduce((acc, val) => acc + val, 0).toFixed(3)

      let newObj = {
        id: csvdata[i].id,
        created_at: csvdata[i].created_at ? formatDate(csvdata[i].created_at) : '',
        created_by: csvdata[i].user.name ?? '',
        account_name: csvdata[i].customer?.account_contact_name ?? '',
        customer_code: csvdata[i].customer?.code ?? '',
        customer_terms: csvdata[i].customer?.customer_terms?.name ?? '',
        customer_ddi: csvdata[i].customer?.account_contact_name ?? '',
        delivery_address: csvdata[i].customer_address?.address ?? '',
        address_note: csvdata[i].customer_address?.location_note ?? '',
        customer_reference: csvdata[i].customer_reference ?? '',
        order_type: csvdata[i].ordertype?.name ?? '',
        sub_order_type: csvdata[i].subordertype?.name ?? '',
        crop_type: csvdata[i].crop?.name ?? '',
        machine: csvdata[i].machine?.name ?? '',
        operators: opr ?? '',
        quoted_price: csvdata[i].quoted_price ?? '',
        sku_location: csvdata[i].skulocation?.name ?? '',
        order_delivery_zone: csvdata[i].orderdeliveryzone?.name ?? '',
        agent: csvdata[i].agent?.name ?? '',
        customer_spread_rate: csvdata[i].custom_spread_rate ?? '',
        products: prtdt ?? '',
        mix_price: mix_price ?? '',
        unit_total: csvdata[i].tons_ordered ?? '',
        unit_remaining: csvdata[i].tons_ordered - csvdata[i].tons_actual ?? '',
        unit_complete: csvdata[i].tons_actual ?? '',
        status:
          // 1) explicit override from backend  OR  both sub-parts finished
          csvdata[i].order_status === 1 ||
          (csvdata[i].dockets_complete === '1' && csvdata[i].tons_complete === '1')
            ? 'Complete'
            : // 2) only the dockets are finished
            csvdata[i].dockets_complete === '1'
            ? 'Dockets Complete'
            : // 3) only the tonnage is finished
            csvdata[i].tons_complete === '1'
            ? 'Tons Complete'
            : // 4) no dockets yet
            csvdata[i].dockets_ready === '0'
            ? ''
            : // 5) actively being entered
            csvdata[i].dockets_ready === '3'
            ? 'In Progress'
            : // 6) ready but not closed off
            csvdata[i].dockets_ready === '1'
            ? 'Ready'
            : // 7) waiting on site to advise
            csvdata[i].dockets_ready === '2'
            ? 'Will Advise'
            : // 8) fallback
              '',

        /* csvdata[i].order_status ==  '1' ? 'Completed' : 'In progress' */
        scheduled_date: csvdata[i].scheduled_date ? formatDate(csvdata[i].scheduled_date) : '',
        scheduled_note: csvdata[i].scheduled_note ?? '',
        admin_note: csvdata[i].admin_note ?? '',
        order_note: csvdata[i].order_note ?? '',
        driver_note: csvdata[i].driver_note ?? '',
        tons_complete_date: csvdata[i].tons_complete_time ?? '',
        docket_date: csvdata[i].dockets_complete_time ?? '',
        docket_details: docket_details ?? '',
        grand_total: grand_total ?? '',
        xero_status: csvdata[i].is_xero === 0 ? `Sent` : `Not Sent`,
      }
      obj = newObj
      dt.push(obj)
    }

    return dt
  }

  const getDataReport = (data) => {
    if (!data || !Array.isArray(data) || data.length !== 2) {
      setError(null)
      setCSVDate(null)
      setDateRange(null)
      return
    }
    setDateRange(data)
    setLoadingDate(true)
    if (data) {
      axios.post(`/api/get_custom_report`, { data }).then((res) => {
        if (!res.data.prepayment || res.data.prepayment.length === 0) {
          setError('No data found')
          setCSVDate(null)
        } else {
          setError(null)
          setCSVDate(res.data.prepayment)
        }
      })
    } else {
      setError(null)
      setDateRange(null)
    }
    setLoadingDate(false)
  }

  const formatDate = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
  }

  const headers = [
    { label: 'ID', key: 'id' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by' },
    { label: 'Account Name', key: 'account_name' },
    { label: 'Customer Code', key: 'customer_code' },
    { label: 'Customer Terms', key: 'customer_terms' },
    { label: 'Customer DDI', key: 'customer_ddi' },
    { label: 'Delivery Address', key: 'delivery_address' },
    { label: 'Address Note', key: 'address_note' },
    { label: 'Customer Reference', key: 'customer_reference' },
    { label: 'Order Type', key: 'order_type' },
    { label: 'Sub Order Type', key: 'sub_order_type' },
    { label: 'Crop Type', key: 'crop_type' },
    { label: 'Machine', key: 'machine' },
    { label: 'Operators', key: 'operators' },
    { label: 'Quoted Price', key: 'quoted_price' },
    { label: 'SKU Location', key: 'sku_location' },
    { label: 'Order Delivery Zone', key: 'order_delivery_zone' },
    { label: 'Agent', key: 'agent' },
    { label: 'Custom Spread Rate', key: 'customer_spread_rate' },
    { label: 'Products', key: 'products' },
    { label: 'Mix Price', key: 'mix_price' },
    { label: 'Tons Ordered', key: 'unit_total' },
    { label: 'Tons Remaining', key: 'unit_remaining' },
    { label: 'Tons Actual', key: 'unit_complete' },
    { label: 'Status', key: 'status' },
    { label: 'Scheduled Date', key: 'scheduled_date' },
    { label: 'Scheduled Note', key: 'scheduled_note' },
    { label: 'Admin Note', key: 'admin_note' },
    { label: 'Order Note', key: 'order_note' },
    { label: 'Driver Note', key: 'driver_note' },
    { label: 'Tons Complete (Date)', key: 'tons_complete_date' },
    { label: 'Dockets Complete (Date)', key: 'docket_date' },
    { label: 'Dockets Detail', key: 'docket_details' },
    { label: 'ALI Grand Total', key: 'grand_total' },
    { label: 'Xero Status', key: 'xero_status' },
  ]

  return (
    <>
      <h1 className="mb-4">Pre Payment (Open)</h1>
      <div className="d-flex align-items-end">
        <div className="d-flex flex-column ">
          <DateRangePicker
            appearance="default"
            placeholder="Select Date Range"
            style={{ width: 230 }}
            onChange={(e) => getDataReport(e)}
            value={dateRange}
          />
        </div>
        <div className="mx-3">
          {loadingDate && (
            <div className="mt-3 btn btn-block btn-outline-info btn-sm">Loading …</div>
          )}

          {!loadingDate && error && (
            <div className="mt-3 btn btn-block btn-outline-info btn-sm">{error}</div>
          )}

          {!loadingDate && csvdata && arrayRestrusture(csvdata).length > 0 && (
            <CSVLink
              className="btn btn-block btn-outline-info btn-sm"
              headers={headers}
              data={arrayRestrusture(csvdata)}
              filename={`${formatDate(dateRange[0])}-${formatDate(dateRange[1])}.csv`}
            >
              Download CSV
            </CSVLink>
          )}
        </div>
      </div>
    </>
  )
}

export default PrePayment
